"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var BrandsCtxItemDir = /** @class */ (function (_super) {
    __extends(BrandsCtxItemDir, _super);
    function BrandsCtxItemDir(props) {
        var _this = _super.call(this, props) || this;
        _this.clickMode = "none";
        return _this;
    }
    BrandsCtxItemDir.prototype.componentWillMount = function () {
        this.setState({ bgColor: "#FFFFFF" });
    };
    BrandsCtxItemDir.prototype.onMouseEnter = function () {
        this.setState({ bgColor: "#89CFF0" });
    };
    BrandsCtxItemDir.prototype.onMouseLeave = function () {
        this.setState({ bgColor: "#FFFFFF" });
    };
    BrandsCtxItemDir.prototype.editButtonClick = function () {
        var _this = this;
        this.clickMode = "edit";
        if (this.props.onEditClick) {
            this.props.onEditClick(this.props.brandId, this.props.dirName);
        }
        setTimeout(function () {
            _this.clickMode = "none";
        }, 1000);
    };
    BrandsCtxItemDir.prototype.getEditButtonRenderObject = function () {
        var cssStyle = {
            borderStyle: "solid",
            borderLeftWidth: "1px",
            borderTopWidth: "1px",
            borderRightWidth: "1px",
            borderBottomWidth: "1px",
            borderRightColor: "transparent",
            borderTopColor: "transparent",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "22px",
            height: "22px",
            backgroundColor: "#2E8B57",
            position: "absolute",
            right: "0px",
            top: "0px",
            boxSizing: "border-box",
            cursor: "pointer"
        };
        return (React.createElement(antd_1.Tooltip, { title: "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C" },
            React.createElement("div", { style: cssStyle, onClick: this.editButtonClick.bind(this) },
                React.createElement(antd_1.Icon, { type: "form", style: { color: "#FFFFFF" } }))));
    };
    BrandsCtxItemDir.prototype.deleteButtonClick = function () {
        var _this = this;
        this.clickMode = "delete";
        if (this.props.onDeleteClick) {
            this.props.onDeleteClick(this.props.brandId, this.props.dirName);
        }
        setTimeout(function () {
            _this.clickMode = "none";
        }, 1000);
    };
    BrandsCtxItemDir.prototype.getDeleteButtonRenderObject = function () {
        var cssStyle = {
            borderStyle: "solid",
            borderLeftWidth: "1px",
            borderTopWidth: "1px",
            borderRightWidth: "1px",
            borderBottomWidth: "1px",
            borderLeftColor: "transparent",
            borderTopColor: "transparent",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "22px",
            height: "22px",
            backgroundColor: "#6B0000",
            position: "absolute",
            left: "0px",
            top: "0px",
            boxSizing: "border-box",
            cursor: "pointer"
        };
        return (React.createElement(antd_1.Tooltip, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" },
            React.createElement("div", { style: cssStyle, onClick: this.deleteButtonClick.bind(this) },
                React.createElement(antd_1.Icon, { type: "delete", style: { color: "#FFFFFF" } }))));
    };
    BrandsCtxItemDir.prototype.onSelectClick = function () {
        console.log('select click');
        if (this.clickMode === "none") {
            if (this.props.onSelectlick) {
                this.props.onSelectlick(this.props.brandId, this.props.dirName);
            }
        }
    };
    BrandsCtxItemDir.prototype.getTitleRenderObject = function () {
        var cssStyle = {
            borderStyle: "solid",
            borderLeftWidth: "1px",
            borderTopWidth: "1px",
            borderRightWidth: "1px",
            borderBottomWidth: "1px",
            borderLeftColor: "transparent",
            borderBottomColor: "transparent",
            borderRightColor: "transparent",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "157px",
            backgroundColor: "#FFFFFF",
            position: "absolute",
            left: "1px",
            bottom: "0px",
            boxSizing: "border-box"
        };
        return (React.createElement(antd_1.Tooltip, { title: this.props.dirName },
            React.createElement("div", { style: cssStyle, onClick: this.deleteButtonClick.bind(this) },
                React.createElement("div", { style: { overflow: "hidden", textOverflow: "ellipsis" } }, this.props.dirName))));
    };
    BrandsCtxItemDir.prototype.render = function () {
        var cssStyle = {
            borderColor: "black",
            borderStyle: "solid",
            borderLeftWidth: "1px",
            borderTopWidth: "1px",
            borderRightWidth: "1px",
            borderBottomWidth: "1px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "160px",
            height: "160px",
            marginLeft: "5px",
            marginTop: "5px",
            marginRight: "0px",
            marginBottom: "5px",
            backgroundColor: this.state.bgColor,
            cursor: "pointer",
            position: "relative"
        };
        return (React.createElement("div", { style: cssStyle, onMouseEnter: this.onMouseEnter.bind(this), onMouseLeave: this.onMouseLeave.bind(this), onClick: this.onSelectClick.bind(this) },
            React.createElement(antd_1.Icon, { type: "folder", style: { fontSize: "42px" } }),
            this.getTitleRenderObject(),
            this.getEditButtonRenderObject(),
            this.getDeleteButtonRenderObject()));
    };
    return BrandsCtxItemDir;
}(React.Component));
exports.default = BrandsCtxItemDir;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_images/ui/component/controls/BrandsCtxItemDir.tsx
// module id = 2368
// module chunks = 0